import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import styles from './buttonSelect.module.scss'
import { Overlay } from 'app/components/common/overlay'

const ButtonSelect = ({
  label,
  options,
  idBy,
  displayBy,
  value,
  onChange,
  className = '',
  overlayClass = '',
  ...rest
}) => {
  const [selectedOption, setSelectedOption] = useState(null)
  const [showOverlay, setShowOverlay] = useState(false)

  const toggleOptions = () => {
    setShowOverlay(!showOverlay)
  }

  const selectOption = (opt) => {
    setShowOverlay(false)
    setSelectedOption(opt)
    if (typeof onChange === 'function') {
      onChange(opt[idBy])
    }
  }

  useEffect(() => {
    const opt = options.find((o) => o[idBy] === value)

    if (opt) {
      selectOption(opt)
    }
  }, [value])

  const optOverlay = (
    <Overlay
      isOpen={showOverlay}
      openChange={setShowOverlay}
      className={`${styles.overlay} ${overlayClass}`}
    >
      <ul>
        {options?.map((opt) => (
          <li
            key={opt[idBy]}
            onClick={() => selectOption(opt)}
            className={opt[idBy] === value ? styles.selected : ''}
          >
            <span>{opt[displayBy]}</span>
          </li>
        ))}
      </ul>
    </Overlay>
  )

  return (
    <div className={`${styles.buttonSelect} ${className}`} {...rest}>
      <button type="button" onClick={() => toggleOptions()}>
        <span className={styles.selected}>{selectedOption?.[displayBy] || label}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={showOverlay ? styles.open : ''}
          width="8"
          height="7"
          viewBox="0 0 8 7"
        >
          <path d="M4,0,8,7H0Z" transform="translate(8 7) rotate(180)" fill="#22233b" />
        </svg>
      </button>

      {optOverlay}
    </div>
  )
}

ButtonSelect.displayName = 'ButtonSelect'

ButtonSelect.propTypes = {
  className: PropTypes.string,
  overlayClass: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.array,
  idBy: PropTypes.string,
  displayBy: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
}

export { ButtonSelect }
